import React from 'react'
import Head from 'next/head'

import Footer from 'modules/marketplace/layout/components/Footer'
import MarketingFooter from 'modules/website/components/MarketingFooter'
import MarketingRetailerPageContent from 'modules/website/components/MarketingRetailerPageContent'

const RetailerPage = () => (
  <>
    <Head>
      <title>Buy wholesale online · Fieldfolio</title>
      <meta name="description" content="Australia's No. 1 Wholesale Platform." />
      <link rel="canonical" href={`${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/retailer`} />
    </Head>
    <MarketingRetailerPageContent />
    <MarketingFooter />
    <Footer />
  </>
)

export default RetailerPage
